export default (props) => {
  return <ul class={`main-menu-list ${props.class || ''}`}>{props.children.map((item, idx) => {
    return <li class='main-menu-list__item' key={idx}>{item}</li>
  })}</ul>
}
